<div class="body-content">
  <div class="aviso-limite-diario">
    <h3>Você sabia que pode limitar o valor diário de consumo dos cartões Meep?</h3>
    <p>Faça recargas mensais e limite o valor diário que pode ser utilizado. Para configurar o limite, vá em <strong>Cartões Meep > Mais informações do cartão > Limite diário</strong>.</p>
  </div>
  <ng-template #prevTemplate>
    <i (click)="changeToPrevDependent()" *ngIf="dependents.length > 0 && currentDependent > 0" class="material-icons">arrow_left</i>
  </ng-template>
  <ng-template #nextTemplate>
    <i (click)="changeToNextDependent()" *ngIf="dependents.length > 0 && dependents.length > currentDependent + 1"
      class="material-icons">arrow_right</i>
  </ng-template>
  <ng-template #dependent let-dependent let-i="index">

    <div class="slide">
      <div class="header-saldo-off" *ngIf="dependent.Status.Id === 0">
        <div class="numbers">
          <div class="titulo" *ngIf="dependent.EhNominal">
            {{ dependent.NomeTitular }}
            {{ dependent.Numero }}
          </div>
          <div class="titulo" *ngIf="!dependent.EhNominal">
            {{ dependent.Tag }}
          </div>
          <div class="balance">Saldo</div>
          <div class="saldo">
            <div class="numero">R$ {{ dependent.Saldo.toString().split('.')[0] }}</div>,{{
            dependent.Saldo.toFixed(2).split('.')[1] }}
          </div>
        </div>
      </div>

      <div class="header-saldo" *ngIf="dependent.Status.Id > 0">
        <div class="numbers">
          <div class="titulo" *ngIf="dependent.EhNominal">
            {{ dependent.NomeTitular }}
            {{ dependent.Numero }}
          </div>
          <div class="titulo" *ngIf="!dependent.EhNominal">
            {{ dependent.Tag }}
          </div>
          <div class="balance">Saldo</div>
          <div class="saldo">
            <div class="numero">R$ {{ dependent.Saldo.toString().split('.')[0] }}</div>,{{
            dependent.Saldo.toFixed(2).split('.')[1] }}
          </div>
        </div>
      </div>

      <div class="row-left border-row" *ngIf="dependent.EhNominal">
        <div class="textOff" *ngIf="dependent.Status.Id === 0">
          <p>Cartão Inativo</p>
        </div>
        <div class="listItem  margin-list">
          <div class="box-slide">
            <div class="saldo-box">
              <div class="numero">R$ {{ dependent.TotalConsumo.toString().split('.')[0] }}</div>,{{
              dependent.TotalConsumo.toFixed(2).split('.')[1] }}

              <h4>Total consumido no mês</h4>
            </div>
            <div class="saldo-box">
              <div class="numero">R$ {{ dependent.EstimativaConsumo.toString().split('.')[0] }}</div>,{{
              dependent.EstimativaConsumo.toFixed(2).split('.')[1] }}

              <h4>Média diária no mês</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row-left" *ngIf="dependent.Status.Id === 0">
        <div class="listItem">
          <div class="box-slide">
            <div class="money-box money-box-Off" *ngIf="dependent.Status.Id !== 3 && dependent.EhNominal" (click)="goToExtract(dependent.Tag, 'nominal')">
              <div class="button is-border box-home button-home padding-btn">Extrato</div>
              <!-- <h4>Média diária no mês</h4> -->
            </div>
            <div class="money-box money-box-Off" *ngIf="!dependent.EhNominal" (click)="goToExtract(dependent.HistoricoAssociacaoId, 'rotativo')">
              <div class="button is-border box-home button-home padding-btn">Extrato</div>
              <!-- <h4>Média diária no mês</h4> -->
            </div>
            <div *ngIf="dependent.Status.Id !== 3 && dependent.EhNominal" class="money-box money-box-Off" (click)="goToRecharge(dependent.Tag, 'nominal')">
              <div class="button is-border button-home padding-btn">Recarga</div>
              <!-- <h4>Total consumido no mês</h4> -->
            </div>
            <div class="money-box" *ngIf="dependent.Status.Id === 3 && dependent.EhNominal" (click)="goToAssociar(dependent.Tag)">
              <div class="button is-border box-home button-home padding-btn">Associar nova via.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row-left" *ngIf="dependent.Status.Id > 0">
        <div class="listItem">
          <div class="box-slide">
            <div class="money-box" *ngIf="dependent.Status.Id !== 3 && dependent.EhNominal" (click)="goToExtract(dependent.Tag, 'nominal')">
              <div class="button is-border box-home button-home padding-btn">Extrato</div>
              <!-- <h4>Média diária no mês</h4> -->
            </div>
            <div class="money-box" *ngIf="!dependent.EhNominal" (click)="goToExtract(dependent.HistoricoAssociacaoId, 'rotativo')">
              <div class="button is-border box-home button-home padding-btn">Extrato</div>
              <!-- <h4>Média diária no mês</h4> -->
            </div>
            <div *ngIf="dependent.Status.Id !== 3 && dependent.EhNominal" class="money-box" (click)="goToRecharge(dependent.Tag, 'nominal')">
              <div class="button button-home padding-btn">Recarga</div>
              <!-- <h4>Total consumido no mês</h4> -->
            </div>
            <div class="money-box" *ngIf="dependent.Status.Id === 3 && dependent.EhNominal" (click)="goToAssociar(dependent.Tag)">
              <div class="button is-border box-home button-home padding-btn">Associar nova via.</div>
            </div>
          </div>
        </div>
      </div>


      <div class="list-menu" *ngIf="dependent.Status.Id > 0">
        <ul>
          <li *ngIf="dependent.EhNominal" (click)="goToSingle(dependent.Tag, 'nominal')">
            <h2>Mais Informações</h2>
            <i class="icon-right-open-big"></i>
          </li>
          <li *ngIf="!dependent.EhNominal" (click)="goToSingle(dependent.HistoricoAssociacaoId, 'rotativo')">
            <h2>Mais Informações</h2>
            <i class="icon-right-open-big"></i>
          </li>
          <br>
          <br>
        </ul>
      </div>

      <div class="list-menu" *ngIf="dependent.Status.Id === 0">
        <ul>
          <li *ngIf="dependent.EhNominal" (click)="goToSingle(dependent.Tag, 'nominal')">
            <h2 style="color: #898989;">Mais Informações</h2>
            <i class="icon-right-open-big"></i>
          </li>
          <li *ngIf="!dependent.EhNominal" (click)="goToSingle(dependent.HistoricoAssociacaoId, 'rotativo')">
            <h2 style="color: #898989;">Mais Informações</h2>
            <i class="icon-right-open-big"></i>
          </li>
          <br>
          <br>
        </ul>
      </div>

    </div>
  </ng-template>
  <!--fim slide-->
  <div class="noDependents" *ngIf="dependentsAlreadySearched && dependents.length == 0">
    <h2>Ainda não há cartões cadastrados!</h2>
    <div class="card"><img src="assets/images/icone-cartao.png"></div>
    <button class="confirma confirma-edit" (click)="goToDependents()">
      Cadastrar um novo cartão
    </button>
  </div>

  <div ng2-carouselamos class="slides-wrapper" [items]="dependents" [$prev]="prevTemplate" [$next]="nextTemplate"
    [$item]="dependent">
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/home/home.component.html